import { DatePicker, Input, Select, Typography, Button, Tooltip } from 'antd';
import { useState, useEffect, useMemo } from 'react';
import { ExtraTableResize } from '../../extraTableResize';
import TableComponent from '../../TableComponent';
import moment from 'moment';
import ja_JP from 'antd/lib/date-picker/locale/ja_JP';
import { FaRegClone } from 'react-icons/fa';
import { convertMomentToStr } from '../../ConvertUtil';

interface IProps {
  searchList: any[];
  rowIndex: number;
  changeRowIndex: (rowIndex: number) => void; // 行を選択する
  mCodeKaitoStatusList: any[];
  setSearchList: (args: any) => void;
  yobidashimotoKbn: string;
}

const JuchuShokaiTable: React.FC<IProps> = (props: IProps) => {
  const [mCodeKaitoStatusList, setMCodeKaitoStatusList] = useState<any[]>([]);
  const [okuriNo, setOkuriNo] = useState('');
  const { Option } = Select;
  /**
   *
   */
  useEffect(() => {
    setMCodeKaitoStatusList(props.mCodeKaitoStatusList);
  }, [props.mCodeKaitoStatusList]);

  /**
   * 編集項目変更イベント
   *
   * @param e
   * @param rowIndex
   * @param coulumName
   */
  const onChangeData = (e: any, rowIndex: number, coulumName: string) => {
    props.setSearchList((data: any) =>
      data.map((item: any, index: number) => {
        if (index === rowIndex) {
          return {
            ...item,
            [coulumName]: e,
          };
        }
        return item;
      })
    );
  };

  /**
   * 送りNoサイト表示
   *
   * @param maeUrl
   * @param ushiroUrl
   * @param okuri
   */
  const openSite = (maeUrl: string, ushiroUrl: string, okuri: string) => {
    if (okuriNo !== null && okuriNo !== '') {
      window.open(maeUrl + okuriNo + ushiroUrl, '_blank');
    } else {
      window.open(maeUrl + okuri + ushiroUrl, '_blank');
    }
  };

  /**
   * カラムの設定
   */
  const columnInit: any = useMemo(() => {
    return [
      {
        title: 'No.',
        dataIndex: 'num',
        width: 100,
        ellipsis: true,
        className: 'clsNumber',
      },
      {
        title: '納入先名',
        dataIndex: 'nou_nm',
        width: 500,
        ellipsis: true,
      },
      {
        title: '製品名',
        dataIndex: 'hin_nm',
        width: 500,
        ellipsis: true,
      },
      {
        title: '規格',
        dataIndex: 'standard',
        width: 600,
        ellipsis: true,
        render: (_: any, record: any) => {
          // 入目&入目単位区分&艶&サイズ&形状&目地
          let recordStandard: any = '';
          if (record['tuya_cd'] != null) {
            recordStandard = ' ' + record['tuya_cd'];
          }
          if (record['hin_size'] != null) {
            recordStandard = recordStandard + ' ' + record['hin_size'];
          }
          if (record['hin_shape'] != null) {
            recordStandard = recordStandard + ' ' + record['hin_shape'];
          }
          if (record['hin_joint'] != null) {
            recordStandard = recordStandard + ' ' + record['hin_joint'];
          }
          recordStandard = record['irime'] + record['irime_tani_kbn'] + recordStandard;
          return <div>{recordStandard}</div>;
        },
      },
      {
        title: '表示色調',
        dataIndex: 'hyouji_iro_cd',
        width: 400,
        ellipsis: true,
      },
      {
        title: '数量',
        dataIndex: 'jyu_su',
        width: 300,
        ellipsis: true,
        className: 'clsQuantity',
      },
      {
        title: '希望納期',
        dataIndex: 'kibo_dt',
        width: 400,
        ellipsis: true,
        className: 'clsDesiredDeliveryDate',
        render: (_: any, record: any) => {
          var strAmPm = '';
          var strDt = '';
          // 日にちの変換
          if (record['kibo_dt'] !== null && record['kibo_dt'] !== '') {
            strDt = convertMomentToStr(record['kibo_dt']);
          }
          // 希望納期_AM/PM_名前
          if (record['kibo_kbn'] !== null && record['kibo_kbn'] !== '') {
            strAmPm = record['name'];
          }
          // 希望納期 & 希望納期_AM/PM
          return <div>{strDt + ' ' + strAmPm}</div>;
        },
      },
      {
        title: '回答納期',
        dataIndex: 'kaito_dt',
        width: 220,
        ellipsis: true,
        className: 'clsAnswerDeliveryDate',
        render: (_: any, record: any, rowIndex: number) => {
          var strDate = record['kaito_dt'];
          var strKbn = record['kaito_kbn'];
          if (props.yobidashimotoKbn === '1') {
            // カレンダーの設定
            var datePicker;
            if (strDate !== null && strDate !== '') {
              datePicker = (
                <DatePicker
                  defaultValue={moment(strDate)}
                  style={{ width: 120 }}
                  locale={ja_JP}
                  format={'YYYY/MM/DD'}
                  onChange={(e) => {
                    onChangeData(e, rowIndex, 'kaito_dt');
                  }}
                />
              );
            } else {
              datePicker = (
                <DatePicker
                  style={{ width: 120 }}
                  locale={ja_JP}
                  format={'YYYY/MM/DD'}
                  onChange={(e) => {
                    onChangeData(e, rowIndex, 'kaito_dt');
                  }}
                />
              );
            }

            //セレクトボックスの設定
            var comboBox = (
              <Select
                defaultValue={strKbn}
                style={{ width: 65 }}
                onChange={(e) => {
                  onChangeData(e, rowIndex, 'kaito_kbn');
                }}
                allowClear
                notFoundContent=" "
              >
                <Option value="1">AM</Option>
                <Option value="2">PM</Option>
                <Option value="3">頃</Option>
              </Select>
            );

            return (
              <div>
                {' '}
                {datePicker} {comboBox}{' '}
              </div>
            );
          } else {
            var strDt = '';
            var strAmPm = '';
            // 日にちの変換
            if (strDate !== null && strDate !== '') {
              strDt = convertMomentToStr(strDate);
            }
            // 回答納期_AM/PM_名前
            if (strKbn !== null && strKbn !== '') {
              strAmPm = record['name'];
            }
            // 回答納期 & 回答納期_AM/PM
            return <div>{strDt + ' ' + strAmPm}</div>;
          }
        },
      },
      {
        title: '状況',
        dataIndex: 'kaijyo_kbn',
        width: 130,
        ellipsis: true,
        render: (_: any, record: any, rowIndex: number) => {
          if (props.yobidashimotoKbn === '1') {
            return (
              <div>
                <Select
                  defaultValue={record['kaijyo_kbn']}
                  style={{ width: 100 }}
                  onChange={(e) => onChangeData(e, rowIndex, 'kaijyo_kbn')}
                  notFoundContent=" "
                >
                  {mCodeKaitoStatusList.length > 0 &&
                    mCodeKaitoStatusList.map((item, i) => {
                      return (
                        <Option key={i} value={item.kbn}>
                          {item.name}
                        </Option>
                      );
                    })}
                </Select>
              </div>
            );
          } else {
            var jyokyo;
            // eslint-disable-next-line array-callback-return
            jyokyo = mCodeKaitoStatusList.map((item: any) => {
              if (item.kbn === record['kaijyo_kbn']) {
                return item.name;
              }
            });

            return <div>{jyokyo}</div>;
          }
        },
      },
      {
        title: '運送便',
        dataIndex: 'transportation',
        width: 400,
        ellipsis: true,
        render: (_: any, record: any) => {
          // 配送業者略名&支店名略名
          if (props.yobidashimotoKbn === '1') {
            return <div>{(record['hai_rnm'] || '') + (record['ai_rnm2'] || '')}</div>;
          } else {
            if (record['kaijyo_kbn'] === '3') {
              return <div>{(record['hai_rnm'] || '') + (record['ai_rnm2'] || '')}</div>;
            } else {
              return '';
            }
          }
        },
      },
      {
        title: '送り状No.',
        dataIndex: 'okuri_no',
        width: 200,
        ellipsis: true,
        render: (_: any, record: any, rowIndex: number) => {
          if (props.yobidashimotoKbn === '1') {
            if (
              record['okuri_no'] != null &&
              record['okuri_no'] !== '' &&
              record['hai_url_mae'] != null &&
              record['hai_url_mae'] !== ''
            ) {
              // 入力項目とサイト表示ボタン
              return (
                <div>
                  <Input
                    defaultValue={record['okuri_no']}
                    maxLength={15}
                    style={{ width: 150 }}
                    onChange={(e) => {
                      setOkuriNo(String(e.target.value));
                      onChangeData(e.target.value, rowIndex, 'okuri_no');
                    }}
                  />
                  <Tooltip title="追跡サイトを開く">
                    <Button
                      type="primary"
                      shape="circle"
                      onClick={() =>
                        openSite(record['hai_url_mae'], record['hai_url_ato'], record['okuri_no'])
                      }
                    >
                      <FaRegClone />
                    </Button>
                  </Tooltip>
                </div>
              );
            } else {
              // 入力項目
              return (
                <div>
                  <Input
                    defaultValue={record['okuri_no']}
                    maxLength={15}
                    style={{ width: 150 }}
                    onChange={(e) => {
                      setOkuriNo(String(e.target.value));
                      onChangeData(e.target.value, rowIndex, 'okuri_no');
                    }}
                  />
                </div>
              );
            }
          } else {
            var url = '';
            if (record['hai_url_ato'] === null) {
              url = record['hai_url_mae'] + record['okuri_no'];
            } else {
              url = record['hai_url_mae'] + record['okuri_no'] + record['hai_url_ato'];
            }
            if (
              record['okuri_no'] != null &&
              record['okuri_no'] !== '' &&
              record['hai_url_mae'] != null &&
              record['hai_url_mae'] !== ''
            ) {
              // リンク サイト表示
              return (
                <Typography.Link href={url} target="_blank">
                  <div>{record['okuri_no']}</div>
                </Typography.Link>
              );
            }
          }
        },
      },
      {
        title: '出荷日',
        dataIndex: 'syukka_dt',
        width: 150,
        ellipsis: true,
        className: 'clsShipDate',
        render: (_: any, record: any, rowIndex: number) => {
          var strDate = record['syukka_dt'];
          if (props.yobidashimotoKbn === '1') {
            // カレンダーの設定
            var datePicker;
            if (strDate !== null && strDate !== '') {
              datePicker = (
                <DatePicker
                  defaultValue={moment(strDate)}
                  style={{ width: 120 }}
                  locale={ja_JP}
                  format={'YYYY/MM/DD'}
                  onChange={(e) => onChangeData(e, rowIndex, 'syukka_dt')}
                />
              );
            } else {
              datePicker = (
                <DatePicker
                  style={{ width: 120 }}
                  locale={ja_JP}
                  format={'YYYY/MM/DD'}
                  onChange={(e) => onChangeData(e, rowIndex, 'syukka_dt')}
                />
              );
            }
            return <div>{datePicker}</div>;
          } else {
            var strDt = '';
            // 日にちの変換
            if (strDate !== null && strDate !== '') {
              strDt = convertMomentToStr(strDate);
            }
          }
          return <div>{strDt}</div>;
        },
      },
      {
        title: '得意先名',
        dataIndex: 'tok_nm',
        width: 500,
        ellipsis: true,
      },
      {
        title: '得意先注文No.',
        dataIndex: 'ttyu_no',
        width: 400,
        ellipsis: true,
      },
      {
        title: '注文日',
        dataIndex: 'jyu_dt',
        width: 150,
        ellipsis: true,
        className: 'clsOrderDate',
        render: (_: any, record: any) => {
          return <div>{moment(record['jyu_dt']).format('YYYY/MM/DD')}</div>;
        },
      },
      {
        title: '納入先住所',
        // 都道府県&市区町村&住所１&住所２
        dataIndex: 'adr',
        width: 830,
        ellipsis: true,
      },
      {
        title: '備考',
        dataIndex: 'biko',
        width: 1000,
        ellipsis: true,
      },
      {
        title: '注文番号',
        dataIndex: 'jyu_no',
        width: 400,
        ellipsis: true,
      },
      {
        title: '基本色調',
        dataIndex: 'kihon_iro_cd',
        width: 400,
        ellipsis: true,
      },
      {
        title: '行No.',
        dataIndex: 'jyugyo_no',
        width: 100,
        ellipsis: true,
        className: 'clsRowNumber',
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mCodeKaitoStatusList, props.setSearchList, okuriNo]);

  const [columns, changeColumns] = useState(columnInit);

  useEffect(() => {
    changeColumns(columnInit);
  }, [columnInit]);

  return (
    <>
      <ExtraTableResize>
        <TableComponent
          columns={columns}
          data={props.searchList}
          minHeight="57vh"
          maxHeight="57vh"
          updateColumns={changeColumns}
          rowIndex={props.rowIndex}
          changeRowIndex={props.changeRowIndex}
          key=""
        />
      </ExtraTableResize>
    </>
  );
};
export default JuchuShokaiTable;
